import React from 'react';
import { ADVISER_PORTAL } from '@/constant/external-links';

const links = [
  {
    icon: <img src="/img/icons/user-circle.svg" className="w-8 h-8" alt="registered user" />,
    title: 'I\'m a registered adviser',
    description: 'Request a new toolkit on the portal.',
    linkText: 'Login here',
    link: ADVISER_PORTAL.TOOLKIT_REQUEST,
    external: true,
  },
  {
    icon: <img src="/img/icons/pencil-line.svg" className="w-8 h-8" alt="unregistered user" />,
    title: 'I\'m not registered yet',
    description: 'Gain access to the toolkit by registering.',
    linkText: 'Register',
    link: '/professionals/register',
    external: false,
  },
];

export const Links = () => {
  return (
    <div className="grid grid-cols-1 gap-8 lg:gap-6 lg:grid-rows-2">
      {links.map((tool, index) => (
        <div
          key={index}
          className="flex flex-col items-center justify-center text-center border border-gray rounded-xl p-6 space-y-2 hover:bg-[#F3F4F8] transition-colors duration-200"
        >
          <div className="w-12 h-12 rounded-lg flex items-center justify-center">
            {tool.icon}
          </div>
          <h2 className="text-lg font-semibold text-[#0C0D1A]">
            {tool.title}
          </h2>
          <p className="text-sm text-[#0C0D1A] font-450">
            {tool.description}
          </p>
          <a
            className="plain-text-link flex items-center"
            href={tool.link}
            rel={tool.external ? 'nofollow' : undefined}
          >
            <span className="mr-2">
              {tool.linkText}
            </span>
            <svg className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"/>
            </svg>
          </a>
        </div>
      ))}
    </div>
  );
};
